import { render, staticRenderFns } from "./TestingPage.vue?vue&type=template&id=2cc5c8e7"
import script from "./TestingPage.vue?vue&type=script&lang=js"
export * from "./TestingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports